import { Component } from '@angular/core';
import {IonicPage, NavController, NavParams, Events} from 'ionic-angular';
import {UserStateProvider} from "../../providers/user-state/user-state";
import {ApiProvider} from "../../providers/api/api";
import {ChallengeProvider} from "../../providers/challenge/challenge";

/**
 * Generated class for the AppSettingsGoalPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-app-settings-goal',
  templateUrl: 'app-settings-goal.html',
})
export class AppSettingsGoalPage {

  initValue: number;
  minutes: number;
  constructor(public navCtrl: NavController, public navParams: NavParams, public userState: UserStateProvider, public api: ApiProvider, public events: Events, private challengeProvider: ChallengeProvider) {
  }

  ionViewDidLoad() {
    this.initValue = this.userState.user.activityTarget;
    this.minutes = this.userState.user.activityTarget;
    console.log('ionViewDidLoad AppSettingsGoalPage');

    console.log(this.challengeProvider.hasInAppChallengeCompleted({"event": "activity:goalUpdated"}));
  }


  add(diff: number) {
    let newValue = this.minutes+diff;
    if(newValue<10) {
      newValue = 10;
    }
    if(newValue>180) {
      newValue = 180;
    }
    this.minutes = newValue;
  }

  saveData() {
    let longer = 0;
    if(this.challengeProvider.hasInAppChallengeCompleted({"event": "activity:goalUpdated"})) {
      longer = (this.initValue && this.minutes > this.initValue)?1:0;
    }
    this.events.publish('activity:goalUpdated', {longer: longer});
    this.api.callPost('/users/'+this.userState.user.id+"/activityTarget", {target: this.minutes}).subscribe(_resp => {
      this.userState.user.activityTarget = this.minutes;
      this.events.publish('user:updated', this.userState.user);
      this.navCtrl.pop();
    })

  }
}



// WEBPACK FOOTER //
// ./src/pages/app-settings-goal/app-settings-goal.ts